import React, {useState,useEffect} from 'react';
import styled from '@emotion/styled';
import {keyframes} from '@emotion/core';
import DetailComponent from './DetailComponent';
import SideMenuComponent from './SideMenuComponent';
import ConfirmationComponent from './ConfirmationComponent';
import LoadingComponent from './LoadingComponent';
import { Item } from 'semantic-ui-react';

const Hop = keyframes`
 from, 0%, to {
    top:6.25rem;
    opacity:0;
  }
80%{
    opacity:0.5;
}
  100%{
    opacity:1;
    top:12.5rem;
  }

`;
const Fade = keyframes`
 from, 0%, to {
    opacity:0;
  }
80%{
    opacity:0.5;
}
  100%{
    opacity:1;
  }

`;
const Slide = keyframes`
 from, 0%, to {
    opacity:0;
    right:-2.5rem;
  }
80%{
    opacity:0.5;
}
  100%{
    opacity:1;
    right: 0rem;
  }
`;

const MobileSlide = keyframes`
 from, 0%, to {
    opacity:0;
    right:-6.25rem;
  }
80%{
    opacity:0.5;
    right: -1.25rem;
}
  100%{
    opacity:1;
    right: 0px;
  }
`;
const SmallMobileSlide = keyframes`
 from, 0%, to {
    opacity:0;
  }
80%{
    opacity:0.5;
}
  100%{
    opacity:1;
  }
`;

const OverlayWrapper = styled.div`
  display: flex;
  position:relative;
  overflow-y:hidden;
`;

const OverlayContainer = styled.div`
    display: flex;
    overflow-y:hidden;
    position: fixed;
    scroll-behavior:none;
    width: 200vw;
    height: 100vh;
    left:-31.25rem;
    top:0px;
    z-index:999;
    /* default/shade/black */

    background: #000000;
    opacity: 0.3;

    @media (max-width: 500px){
      width: 300vw;
      background: var(--color-white);
      opacity: 1;
    }
`;

const CardContainer = styled.div`
    overflow: scroll;
    padding: var(--space-48);
    justify-self:center;
    position: fixed;
    width: auto;
    height: 48.3rem;
    
    /* default/shade/white */
    z-index:999;
    background:var(--color-white);
    box-shadow: 0px 2.76726px 2.21381px rgba(0, 0, 0, 0.0196802), 0px 6.6501px 5.32008px rgba(0, 0, 0, 0.0282725), 0px 12.5216px 10.0172px rgba(0, 0, 0, 0.035), 0px 22.3363px 17.869px rgba(0, 0, 0, 0.0417275), 0px 41.7776px 33.4221px rgba(0, 0, 0, 0.0503198), 0px 100px 80px rgba(0, 0, 0, 0.07);
    border-radius: var(--space-24);
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    animation: ${Fade} 0.4s linear;

    @media (max-width: 500px){
      box-shadow: none;
      background: none;
    }

`;

const SideSlideComponent = styled.div`
    display:flex;
    position: fixed;
    padding: var(--space-20);
    height: 70vh;
    right: 0rem;
    top: 0px;
    z-index:999;
    /* default/shade/black */

    background: var(--color-white);
    animation: ${Slide} 0.4s linear;

    @media (max-width: 1100px){
    
      height: 64rem;
      right: -1rem;
    }

    @media (max-width: 800px){
    
      right: 0px;
      animation: ${MobileSlide} 0.4s linear;
    }
   @media (max-width: 500px){
   
    right: -1.94rem;
    animation: ${SmallMobileSlide} 0.4s linear;
   }
`;


function OverlayComponent (props) {
    const [quantity, setQuantity] = useState(1);
    const [attribute, setAttribute] = useState('');
    const [show, setShow] = useState(true);
    const [slide, setSlide] = useState(false);
    const [confirm, setConfirm] = useState(false);
    const [fade, setFade] = useState('');
    const [price, setPrice] = useState({
        price: '',
        discount: ''
    });


    const closeSlide = () => {
        setShow(true);
        setSlide(false);
      
    };

    const slideMenu = () => {
        setSlide(true);
        setShow(false);
    };

    return (
      <>
      {props.display ? 
        <OverlayWrapper>
          
            <OverlayContainer>

            </OverlayContainer>
            
            {show ? 
            <CardContainer>
                <DetailComponent
                    setDisplay={props.setDisplay}
                    setSlide={slideMenu}
                    item={props.item}
                    setQuantity={setQuantity}
                    setAttribute={setAttribute}
                    setPrice={setPrice}
                    showCard={setShow}
                />
                </CardContainer>
                :
                null
            }
            
            {slide ?
            <SideSlideComponent>
                <SideMenuComponent
                    show={closeSlide}
                    confirm={setConfirm}
                    item={props.item}
                    quantity={quantity}
                    attribute={attribute}
                    price={price}
                />
            </SideSlideComponent>
            :
            null
            }
        
        </OverlayWrapper>
        :
        null
      }
        </>
    );
};

export default OverlayComponent;
